import inverted from './inverted.json';
import normal from './normal.json';
import thick from './thick.json';

export default { normal, inverted, thick };
